import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import {
  AccredibleResponsiveBreakpoint,
  AccredibleResponsiveHelper,
} from '@accredible-frontend-v2/utils/responsive-helper';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostListener,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { first, take } from 'rxjs/operators';
import { SpotlightProfile } from '../../../../core/models/spotlight-profiles.model';
import { DirectoryState } from '../../../../core/stores/directory/directory.reducer';
import { selectDirectory } from '../../../../core/stores/directory/directory.selectors';
import { SpotlightEventTrackingService } from '../../../../shared/services/event-tracking/spotlight-event-tracking.service';

@Component({
  selector: 'sl-profile-list-card',
  templateUrl: './profile-list-card.component.html',
  styleUrls: ['./profile-list-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileListCardComponent implements OnInit {
  private readonly _route = inject(ActivatedRoute);
  private readonly _language = inject(AccredibleLanguageService);
  private readonly _eventTrackingService = inject(SpotlightEventTrackingService);
  private readonly _directoryStore = inject(Store<DirectoryState>);

  profile = input<SpotlightProfile>();

  mappedCredentials = computed(() => {
    if (!this.profile() || !this.profile().credentials) {
      return;
    }

    return this.profile().credentials.map((credential) => credential.name);
  });

  readonly directory$ = this._directoryStore.select(selectDirectory);
  readonly languageCode$ = this._language.languageCode$;
  readonly queryParams = this._route.snapshot.queryParams;

  skillsLimit = 3;
  credentialLimit = 3;
  isMobile = false;

  @HostListener('window:resize')
  onResize(): void {
    this._checkForMobileDisplay();
  }

  ngOnInit(): void {
    this._checkForMobileDisplay();
  }

  trackEvent(socialNetwork: string): void {
    this.directory$.pipe(first((directory) => !!directory?.id)).subscribe((directory) => {
      this._eventTrackingService
        .trackEvent(directory.id, 'directory', socialNetwork)
        .pipe(take(1))
        .subscribe();
    });
  }

  private _checkForMobileDisplay(): void {
    if (AccredibleResponsiveHelper.isScreenLessThan(AccredibleResponsiveBreakpoint.XS)) {
      this.skillsLimit = 1;
      this.credentialLimit = 1;
      this.isMobile = true;
    } else if (AccredibleResponsiveHelper.isScreenLessThan(AccredibleResponsiveBreakpoint.SM)) {
      this.skillsLimit = 2;
      this.credentialLimit = 2;
      this.isMobile = true;
    } else {
      this.skillsLimit = 3;
      this.credentialLimit = 3;
      this.isMobile = false;
    }
  }
}
